// src/utils/revampTheme.js
//
// The UI revamp's theme (src/theme-v2.css) only applies while <html> has the
// class `regx-v2`. Patient-facing pages keep their original look (user,
// 2026-11-03), so the class is never on while one of them is showing.

import { UI_REVAMP_ENABLED } from "../config/featureFlags";

// Every page a patient opens from a text or an email. A new patient-facing page
// must be added here (and to AppShell's isPublic, ChatLauncher, TenantHeader).
const PATIENT_FACING_PREFIXES = ["/esign", "/referral-form", "/health-survey"];

export const isPatientFacingPath = (path) =>
  PATIENT_FACING_PREFIXES.some((p) => path === p || String(path || "").startsWith(`${p}/`));

export const applyRevampTheme = (path, enabled = UI_REVAMP_ENABLED, root = document.documentElement) => {
  root.classList.toggle("regx-v2", !!enabled && !isPatientFacingPath(path));
};
